var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71 10.9a1 1 0 0 0-1 1v23a2 2 0 0 0 .59 1.4l2.21 2.21a2 2 0 0 0 1.41.59h30.16a2 2 0 0 0 1.41-.59l2.21-2.21a2 2 0 0 0 .59-1.41v-23a1 1 0 0 0-1-1H6.71zm33.58 2.3-14.6 14.08a1 1 0 0 1-1.38 0L9.71 13.2zM8 35.8v-21l14 13.44a2 2 0 0 0 1.38.56h3.23a2 2 0 0 0 1.39-.55l14-13.49v21a1 1 0 0 1-1 1H9a1 1 0 0 1-1-.96"
  })));
};
export default SvgEnvelope;